import { render, staticRenderFns } from "./data-view-canvas.vue?vue&type=template&id=7cde21ce&scoped=true&"
import script from "./data-view-canvas.vue?vue&type=script&lang=js&"
export * from "./data-view-canvas.vue?vue&type=script&lang=js&"
import style0 from "./data-view-canvas.vue?vue&type=style&index=0&id=7cde21ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cde21ce",
  null
  
)

export default component.exports